import React from 'react';

const NotFound = () => {
    return (
        <div>
           <p>Page Not Found</p> 
        </div>
    );
}

export default NotFound;
